import BaseRepository from "@/baseRepository/BaseRepository";
const supplierProductsResource = `/api/v1/supplierproducts`;


export default {
    getSupplierCategoryProducts(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${supplierProductsResource}/category-types`, {
            baseURL,
            headers,
            params
        });
    },
}